<template>
  <nav v-if="itemAction.attributes.is_deleted != true">
    <v-row no-gutters >
      <v-col cols="12" class="d-flex ml-9" style="position: absolute;" >
        <v-spacer/>
         <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon
              class="pa-1"
              data-testid="delete-icon"
              dense
              v-on="on"
              @click.stop="preDeleteWorkflowAction(itemAction)"
            >
              mdi-delete-circle
            </v-icon>
              </template>
              <span>{{ $t('deleteAction') }}</span>
            </v-tooltip>
      </v-col>
    </v-row>
    <v-expansion-panel v-if="!loading" class="elevation-0 mt-0 rounded-lg"  :style="itemAction.attributes.is_active == false?'border:2px solid #FFE0B2':''">
      <v-expansion-panel-header expand-icon="mdi-menu-down" class="pa-0" data-testid="panel-header">
            <v-row no-gutters>
                <v-col :cols="mobile() ? 12 : 2" class="pa-3" style="justify-content:end" :class="mobile() ? 'pb-0' : ''">
                <v-icon v-if="typeAction =='share_hub' || typeAction =='share_activity'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                    mdi-share-variant
                </v-icon>
                <v-icon v-if="typeAction =='delay_duration'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                  mdi-timer-sand-complete
                </v-icon>
                <v-icon v-if="typeAction =='delay_until'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                  mdi-calendar-today
                </v-icon>
                <v-icon v-if="typeAction =='custom_message'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                  mdi-email-outline
                </v-icon>
                <v-icon v-if="typeAction =='remove_from_hub' || typeAction =='remove_from_activity'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                    mdi-account-remove-outline
                </v-icon>
                <v-icon v-if="typeAction =='certificate'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                  mdi-school-outline
                </v-icon>
                <v-icon v-if="typeAction =='event'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30" >
                  mdi-calendar-today
                </v-icon>
                </v-col>
                <v-col :cols="mobile() ? 12 : 10" class="pa-3">
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-if="typeAction =='share_hub'"> 
                  {{$t('shareHubAction')}}
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='share_activity'"> 
                  {{$t('shareActAction')}}
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='delay_duration'"> 
                  {{$t('delayAmountOfTimeAction')}}
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='delay_until'">
                  {{$t('delayUntilDateAndTimeAction')}} 
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='custom_message'">
                  {{$t('sendCustomMessageAction')}} 
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='remove_from_hub'">
                  {{$t('removeFromHubAction')}} 
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='remove_from_activity'">
                  {{$t('removeFromActivityAction')}} 
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='certificate'">
                  {{$t('certificateAction')}} 
                </v-card-title>
                <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" v-else-if="typeAction =='event'">
                  {{$t('eventAction')}} 
                </v-card-title>
                <v-card-subtitle v-if="typeAction =='share_hub' || typeAction =='share_activity' || typeAction =='remove_from_hub' || typeAction =='remove_from_activity'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span :class="itemAction.attributes.is_broken ? 'error--text': ''">{{ itemAction.attributes.title }}</span>
                </v-card-subtitle>
                <v-card-subtitle v-else-if="typeAction =='delay_duration'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span> 
                    {{ $tc('delayActionDays', secondsToDays(delayTime), { numberDays: secondsToDays(delayTime) }) }}, 
                    {{ $tc('delayActionHours', secondsToHours(delayTime), { numberHours: secondsToHours(delayTime) }) }},  
                    {{ $tc('delayActionMinutes', secondsToMinutes(delayTime), { numberMinutes: secondsToMinutes(delayTime) }) }}
                  </span>
                </v-card-subtitle>
                <v-card-subtitle v-else-if="typeAction =='delay_until'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span v-if="delayTillTime != null"> 
                    {{ moment(new Date(delayTillTime)).format('YYYY-MM-DD') }} 
                    {{ moment(new Date(delayTillTime)).format('HH:mm') }}
                  </span>
                </v-card-subtitle>
                <v-card-subtitle v-if="typeAction =='custom_message'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span :class="itemAction.attributes.is_broken ? 'error--text': ''">{{ $t('viaMail') }}</span>
                </v-card-subtitle>
                <v-card-subtitle v-if="typeAction =='certificate'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span :class="itemAction.attributes.is_broken ? 'error--text': ''">{{ $t('viaMail') }}</span>
                </v-card-subtitle>
                <v-card-subtitle v-else-if="typeAction =='event'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span :class="itemAction.attributes.is_broken ? 'error--text': ''">{{ itemAction.attributes.event_title }}</span>
                  <p class="mb-0" v-if="itemAction.attributes.event_at != null">
                    {{ moment(new Date(itemAction.attributes.event_at)).format('YYYY-MM-DD') }} 
                    {{ moment(new Date(itemAction.attributes.event_at)).format('HH:mm') }}
                  </p>
                </v-card-subtitle>       
                </v-col>
            </v-row>
      </v-expansion-panel-header>
      <v-expansion-panel-content v-if="typeAction =='share_hub'" data-testid="share_hub_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <!-- <v-select
                v-model="itemSelected"
                background-color="background"
                class="rounded-xxl select-items my-2"
                :items="hubs"
                item-text="attributes.title"
                item-value="id"
                return-object
                solo   
                append-icon="mdi-chevron-down"
                dense
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  maxHeight: 130,
                  maxWidth: 560,
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                data-testid= "item-select"
                :error-messages="errors"
              >
                <template v-slot:item="{ item }">
                 <span class="text-subtitle-2">  {{ item.attributes.title }}</span>
                </template>
              </v-select> -->

              <v-autocomplete
                v-model="itemSelected"
                :menu-props="{
                  rounded: 'xxl',
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                background-color="background"
                :items="hubs"
                color="white"
                hide-selected
                item-text="attributes.title"
                item-value="id"
                :placeholder="$t('typeToSearch')"
                return-object
                solo
                dense
                class="rounded-xxl text-body-2 px-1"
                :readonly="hubs.length == 1"
                data-testid="item-select"
              >
              <template v-slot:no-data>
                  <p class="mx-5 mt-4">{{ $t('noDataText') }}</p>
                </template>

                <template v-slot:selection="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>
              </v-autocomplete>

              <p class="text-body-2 font-weight-bold mb-2">
              {{ $t('labelMessage') }}
              </p>
              <editor-text-area-template  class="editor editor-text-area-template" :content="messageShare"
                :placeholder="$t('customMessageActionMessagePlaceholder')" data-testid="message-textarea" @updateContent="updateContentShareMessage"
              />
              <div v-if="errorMsg" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ errorMsg }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.resource != null ? preEditWorkflowAction(itemSelected.id,itemAction) : saveAction(itemSelected.id,itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content  v-else-if="typeAction =='share_activity'" data-testid="share_activity_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <!-- <v-select
                v-model="itemSelected"
                background-color="background"
                class="rounded-xxl select-items my-2"
                :items="activities"
                item-text="attributes.title"
                item-value="id"
                return-object
                solo
                append-icon="mdi-chevron-down"
                dense
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  maxHeight: 130,
                  maxWidth: 560,
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                data-testid= "item-select"
                :error-messages="errors"
              >
                <template v-slot:item="{ item }">
                  <span class="text-subtitle-2 ">{{ item.attributes.title }}</span>
                </template>
              </v-select> -->

              <v-autocomplete
                v-model="itemSelected"
                :items="activities"
                item-text="attributes.title"
                item-value="id"
                :menu-props="{ rounded: 'xxl' }"
                :placeholder="$t('typeToSearch')"
                return-object
                hide-selected
                dense
                solo
                class="rounded-xxl text-body-2 px-1"
                :readonly="activities.length == 1"
                data-testid="item-select"
              >
                <template v-slot:no-data>
                  <p class="mx-5 mt-4">{{ $t('noDataText') }}</p>
                </template>
                <template v-slot:selection="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>
              </v-autocomplete>

              <p class="text-body-2 font-weight-bold mb-2">
              {{ $t('labelMessage') }}
              </p>
              <editor-text-area-template  class="editor editor-text-area-template" :content="messageShare"
                :placeholder="$t('customMessageActionMessagePlaceholder')" data-testid="message-textarea" @updateContent="updateContentShareMessage"
              />
              <div v-if="errorMsg" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ errorMsg }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.resource != null ? preEditWorkflowAction(itemSelected.id,itemAction) : saveAction(itemSelected.id,itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-else-if="typeAction =='delay_duration'" data-testid="delay_duration_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <v-row>
                <v-col cols="12" md="4">
                  <span>{{ $t('labelDays') }}</span>
                  <v-text-field
                    v-model="days"
                    data-testid="days-input"
                    type="number"
                    :max="2000"
                    :min="0"
                    solo
                    hide-details="auto"
                    class="text-body-2"
                    @keypress="preventLetters"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <span>{{ $t('labelHours') }}</span>
                  <v-text-field
                    v-model="hours"
                    data-testid="hours-input"
                    type="number"
                    :max="23"
                    :min="0"
                    solo
                    hide-details="auto"
                    class="text-body-2"
                    @keypress="preventLetters"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <span>{{ $t('labelMinutes') }}</span>
                  <v-text-field
                    v-model="minutes"
                    data-testid="minutes-input"
                    type="number"
                    :max="59"
                    :min="0"
                    solo
                    hide-details="auto"
                    class="text-body-2"
                    @keypress="preventLetters"
                  ></v-text-field>
                </v-col>
              </v-row>
              <div v-if="error" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ error }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.delay_duration != null ? preEditWorkflowAction(days,itemAction) : saveAction(days, itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>

      </v-expansion-panel-content>
      <v-expansion-panel-content v-else-if="typeAction =='delay_until'" data-testid="delay_until_content">
        <v-row data-testid="date-dependent-row">
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
            <v-row no-gutters>
            <v-col cols="12" md="6">  
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  color="accent"
                  v-model="dateSelected"
                  v-bind="attrs"
                  v-on="on"
                  clearable
                  readonly
                  :rules="dateRules"
                  data-testid="date-input"
                  class="mr-3"
                >
                  <template v-slot:prepend>
                    <v-icon color="accent">mdi-calendar</v-icon>
                  </template>
                  <template v-slot:label>
                    <div>
                      <span
                        class="text-subtitle-2 accent--text"
                        >{{ $t("chooseDate") }}</span
                      >
                    </div>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker 
                v-model="dateSelected" 
                no-title 
                :allowed-dates="allowedDates"
              >
              </v-date-picker>
            </v-menu>
            </v-col>
            <v-col cols="12" md="6">
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-height="200"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  color="accent"
                  v-model="timeSelected"
                  v-bind="attrs"
                  v-on="on"
                  readonly
                  clearable
                  :rules="timeRules"
                  data-testid="time-input"
                  class="ml-3 delay-action-time"
                >
                  <template v-slot:prepend>
                    <v-icon color="accent">mdi-clock-outline</v-icon>
                  </template>
                  <template v-slot:label>
                    <div>
                      <span
                        class="text-subtitle-2 accent--text"
                        data-testid="time-label"
                        >{{ $t("chooseTime") }} ({{ timezone }})</span
                      >
                    </div>
                  </template>
                </v-text-field>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in time"
                  :key="index"
                  @click="timeSelected = item"
                  dense
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            </v-col>
            </v-row>
            <div v-if="error" class="ml-3" data-testid="error-message">
              <span class="error--text text-caption"> {{ error }}</span> 
            </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"       
              @click="itemAction.attributes.delay_till_time != null ? preEditWorkflowAction(dateSelected,itemAction) : saveAction(dateSelected, itemAction)"
            >{{ $t('confirm') }}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-else-if="typeAction =='custom_message'" data-testid="custom_message_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelSubject') }}
              </p>
              <v-text-field
                v-model="subject"
                data-testid="subject-input"
                solo
                elevation="6"
                class="rounded-lg text-body-2"
                :rules="subjectRules"
                :placeholder="$t('customMessageActionSubjectPlaceholder')"
              />
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelMessage') }}
              </p>
              <editor-text-area-template  class="editor editor-text-area-template" :content="message"
                :placeholder="$t('customMessageActionMessagePlaceholder')" data-testid="message-textarea" @updateContent="updateContentCustomMessage"
              />
              <div v-if="errorMsg" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ errorMsg }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.custom_subject != null ? preEditWorkflowAction(subject,itemAction) : saveAction(subject, itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-else-if="typeAction =='remove_from_hub'" data-testid="remove_from_hub_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <!-- <v-select
                v-model="itemSelected"
                background-color="background"
                class="rounded-xxl select-items  my-2"
                :items="hubs"
                item-text="attributes.title"
                item-value="id"
                return-object
                solo   
                append-icon="mdi-chevron-down"
                dense
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  maxHeight: 130,
                  maxWidth: 560,
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                data-testid= "item-select"
                :error-messages="errors"
              >
                <template v-slot:item="{ item }">
                 <span class="text-subtitle-2">  {{ item.attributes.title }}</span>
                </template>
              </v-select> -->

              <v-autocomplete
                v-model="itemSelected"
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                background-color="background"
                :items="hubs"
                item-text="attributes.title"
                item-value="id"
                :placeholder="$t('typeToSearch')"
                return-object
                clearable
                solo
                dense
                :readonly="hubs.length == 1"
                class="rounded-xxl text-body-2 px-1"
                data-testid="item-select"
              >
              <template v-slot:no-data>
                  <p class="mx-5 mt-4">{{ $t('noDataText') }}</p>
                </template>

                <!-- Selection Slot -->
                <template v-slot:selection="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>

                <!-- Item Slot -->
                <template v-slot:item="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>
              </v-autocomplete>

            </v-form>
          </v-col>
        </v-row>
                <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.resource != null ? preEditWorkflowAction(itemSelected.id,itemAction) : saveAction(itemSelected.id,itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content  v-else-if="typeAction =='remove_from_activity'" data-testid="remove_from_activity_content">
        <v-row  no-gutters>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <!-- <v-select
                v-model="itemSelected"
                background-color="background"
                class="rounded-xxl select-items  my-2"
                :items="activities"
                item-text="attributes.title"
                item-value="id"
                return-object
                solo
                append-icon="mdi-chevron-down"
                dense
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  maxHeight: 130,
                  maxWidth: 560,
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                data-testid= "item-select"
                :error-messages="errors"
              >                
                <template v-slot:item="{ item }">
                  <span class="text-subtitle-2 ">{{ item.attributes.title }}</span>
                </template>
              </v-select> -->

              <v-autocomplete
                v-model="itemSelected"
                :menu-props="{
                  closeOnContentClick: true,
                  rounded: 'xxl',
                  maxHeight: 130,
                  maxWidth: 560,
                  contentClass: 'mt-n1 workflow-action-select',
                }"
                :items="activities"
                color="white"
                hide-selected
                item-text="attributes.title"
                item-value="id"
                :placeholder="$t('typeToSearch')"
                return-object
                clearable
                solo
                dense
                class="rounded-xxl text-body-2 px-1"
                :readonly="activities.length == 1"
                data-testid="item-select"
              >
                <template v-slot:no-data>
                  <p class="mx-5 mt-4">{{ $t('noDataText') }}</p>
                </template>

                <template v-slot:selection="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>

                <template v-slot:item="{ item }">
                  <span v-if="item && item.attributes" class="text-subtitle-2">
                    {{ item.attributes.title }}
                  </span>
                </template>
              </v-autocomplete>

            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.resource != null ? preEditWorkflowAction(itemSelected.id,itemAction) : saveAction(itemSelected.id,itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <v-expansion-panel-content v-else-if="typeAction =='certificate'" data-testid="certificate_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelSubject') }}
              </p>
              <v-text-field
                v-model="subject"
                data-testid="subject-input"
                solo
                elevation="6"
                class="rounded-lg text-body-2"
                :rules="subjectRules"
                :placeholder="$t('certificateActionSubjectPlaceholder')"
              />
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelMessage') }}
              </p>
              <editor-text-area-template  class="editor editor-text-area-template" :content="message"
                :placeholder="$t('certificateActionMessagePlaceholder')" data-testid="message-textarea" @updateContent="updateContentCertificate"
              />
              <div v-if="errorMsg" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ errorMsg }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.custom_subject != null ? preEditWorkflowAction(subject,itemAction) : saveAction(subject, itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="typeAction =='certificate'" no-gutters>
          <v-col cols="12" align="left">
            <v-btn @click="downloadCertificate" data-testid="review-certificate-button" text class="text-none no-text-transform no-hover" color="accent">{{ $t('reviewCertificate') }}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>

      <v-expansion-panel-content v-else-if="typeAction =='event'" data-testid="event_content">
        <v-row>
          <v-col cols="12">
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent
            >

              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelEventTitle') }}
              </p>
              <v-text-field
                v-model="event.title"
                data-testid="event-title-input"
                solo
                elevation="6"
                class="rounded-lg text-body-2"
                :rules="titleRules"
                :placeholder="$t('formTitlePlaceholder')"
              />
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelEventType') }}
              </p>
              <v-select
                id="event-type-dropdown"
                v-model="event.type"
                :items="['digital', 'physical']"
                outlined
                dense
                append-icon="mdi-chevron-down"
                :menu-props="{ offsetY: true }"
                ref="roleFilter"
                data-testid="event-type-input"
              >
                <template v-slot:item="{ item }">
                  <span class="text-subtitle-2 ">{{ $t(item) }}</span>
                </template>

                <template v-slot:selection="{ item }">{{ $t(item) }}</template>
              </v-select>

              <template v-if="event.type == 'physical'">
                <p class="text-body-2 font-weight-bold mb-2">
                  {{ $t('labelAddress') }}
                </p>  
                
                <vue-google-autocomplete
                 v-model="event.data.address"
                  ref="autocomplete"
                  id="map"
                  classname="rounded-lg text-body-2 autocomplete-google"
                  :placeholder="$t('eventAddressPlaceholder')"
                  v-on:placechanged="onPlaceSelected"
                  data-testid="address-input"
                  >
                </vue-google-autocomplete>
              </template>


              <template v-if="event.type == 'digital'">
                <p class="text-body-2 font-weight-bold mb-2">
                  {{ $t('labelLink') }}
                </p>
                <v-text-field
                  v-if="event.type == 'digital'"
                  v-model="event.data.url"
                  data-testid="address-input"
                  solo
                  elevation="6"
                  class="rounded-lg text-body-2"
                  :placeholder="$t('eventLinkPlaceholder')"
                  :rules="urlRules"
                />

              </template>

              <v-row>
                <v-col cols="6">
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="accent"
                        v-model="dateSelected"
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        readonly
                        :rules="dateRules"
                        data-testid="date-input"
                        class="mr-0"
                      >
                        <template v-slot:prepend>
                          <v-icon color="accent">mdi-calendar</v-icon>
                        </template>
                        <template v-slot:label>
                          <div>
                            <span
                              class="text-subtitle-2 accent--text"
                              >{{ $t("chooseEventDate") }}</span
                            >
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker 
                      v-model="dateSelected" 
                      no-title 
                      :allowed-dates="allowedDates"
                      :min="minDate"
                      @input="menu = false"
                    >
                    </v-date-picker>
                  
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-height="200"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        color="accent"
                        v-model="timeSelected"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        clearable
                        :rules="timeRules"
                        data-testid="time-input"
                        class="ml-1 delay-action-time"
                      >
                        <template v-slot:prepend>
                          <v-icon color="accent">mdi-clock-outline</v-icon>
                        </template>
                        <template v-slot:label>
                          <div>
                            <span
                              class="text-subtitle-2 accent--text"
                              data-testid="time-label"
                              >{{ $t("chooseTime") }} ({{ timezone }})</span
                            >
                          </div>
                        </template>
                      </v-text-field>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in time"
                        :key="index"
                        @click="timeSelected = item"
                        @input="menu = false"
                        dense
                      >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              
              <v-checkbox
                v-model="event.has_list"
                data-testid="has-list-checkbox"
                color="accent"
                class="black--text option rounded-xxl ma-0 ml-0 mb-4"
                :class="{ 'selected' : event.has_list}"
                hide-details
              >
                <template v-slot:label>
                  <div>
                    <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t("labelEventHasList") }}</span> 
                  </div>
                </template>
              </v-checkbox>


              <template v-if="event.has_list">
                <p class="text-body-2 font-weight-bold mb-2">
                  {{ $t('labelEventTutors') }}
                </p>

                <v-autocomplete
                  v-model="selectedUsers"
                  :menu-props="{
                    rounded: 'xxl'
                  }"
                  :items="items"
                  :loading="isLoading"
                  :search-input.sync="search"
                  color="white"
                  hide-selected
                  item-text="searchTerm"
                  item-value="id"
                  :placeholder="$t('typeToSearch')"
                  return-object
                  multiple
                  chips
                  clearable
                  solo
                  class="rounded-xxl text-body-2 px-1"
                  @blur="closeSearch"
                  data-testid="tutors-input"
                  @input="checkUserExist"
                  @change="change"
                >
                  <template v-slot:no-data>
                    <p class="mx-5 mt-4">
                      {{ $t('noDataText') }}
                    </p>
                  </template>
                  <template v-slot:selection="data">
                    <v-chip
                      v-bind="data.attrs"
                      close
                      data-testid="user-chip"
                      @click:close="remove(data.item)"
                    >
                      <v-avatar left>
                        <v-img
                          v-if="data.item.attributes.avatar_thumb == null"
                          src="../../assets/user_images/profile-avatar.png"
                        />
                        <v-img
                          v-else
                          :src="data.item.attributes.avatar_thumb"
                        />
                      </v-avatar>
                      {{ data.item.attributes.first_name }} {{ data.item.attributes.last_name }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-item-avatar rounded="lg" >
                      <img
                        v-if="data.item.attributes.avatar_thumb == null"
                        src="../../assets/user_images/profile-avatar.png"
                      >
                      <img
                        v-else
                        :src="data.item.attributes.avatar_thumb"
                      >
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.attributes.first_name + ' ' + data.item.attributes.last_name }} </v-list-item-title>
                      <v-list-item-subtitle> {{ data.item.attributes.email }} </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
                
              </template> 
              <template v-if="event.has_list && (validateDateAndTime() || event.event_at)">
                <p class="mb-4">{{ $t('labelReminders') }}</p>
                <v-col
                    class="pa-0"
                    cols="12"
                >
                  <v-row
                      v-for="(i, index) in event.reminders"
                      :key="index"
                      class="mb-1"
                  >
                    <v-col class="d-flex align-center pa-2" cols="4">
                    
                      <v-text-field
                          :id="'days_' + index"
                          v-model="event.reminders[index].days"
                          data-testid="event-reminders-input"
                          type="number"
                          min="0"
                          class="reminder-input"
                          @change="getDateFromDays(index)"
                          :error-messages="event.reminders[index].error"
                          @input="getDateFromDays(index)"
                        />
                       
                    </v-col>
                    <v-col cols="3" class="justify-start align-center d-flex pa-2">
                      <v-card-subtitle class="pa-0">{{ $t('eventDaysBefore') }}</v-card-subtitle>
                    </v-col>
                    <v-col cols="4" class="d-flex justify-end align-center pa-2">
                      <v-card-subtitle class="pa-0">
                            ({{
                                event.reminders[index].date
                                    ? moment(
                                      event.reminders[index].date
                                      ).format("DD-MM-YYYY")
                                    : ""
                            }})</v-card-subtitle
                        >
                      
                        <v-btn
                          data-testid="delete-field-button"
                          icon
                          small
                          fab 
                          rounded
                          @click.stop="removeRow(index)"
                        >
                          <v-icon small>
                            mdi-delete
                          </v-icon>
                        </v-btn>

                    </v-col>
                  </v-row>

                  <v-row class="justify-end align-center mb-1 mt-4">
                      <v-col
                          cols="12"
                          class="d-flex justify-center align-center py-0"
                      >
                          <v-btn
                              class="d-flex align-center justify-center"
                              v-if="event.reminders.length < 15"
                              variant='text'
                              color="primary"
                              @click="addNewRow()"
                          >
                              <v-icon>mdi-plus</v-icon>
                              {{ $t("AddMoreReminders") }}
                          </v-btn>
                      </v-col>
                  </v-row>
                </v-col>
              </template>
            
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelSubject') }}
              </p>
              <v-text-field
                v-model="subject"
                data-testid="subject-input"
                solo
                elevation="6"
                class="rounded-lg text-body-2"
                :rules="subjectRules"
                :placeholder="$t('certificateActionSubjectPlaceholder')"
              />
              <p class="text-body-2 font-weight-bold mb-2">
                {{ $t('labelMessage') }}
              </p>
              <editor-text-area-template  class="editor editor-text-area-template" :content="message"
                :placeholder="$t('certificateActionMessagePlaceholder')" data-testid="message-textarea" @updateContent="updateContentCertificate"
              />
              <div v-if="errorMsg" class="ml-3" data-testid="error-message">
                <span class="error--text text-caption"> {{ errorMsg }}</span> 
              </div>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" align="right">
            <v-btn 
              small 
              class="text-none px-2" 
              color="accent"
              :disabled="!itemAction.confirm"
              data-testid="confirm-button"    
              @click="itemAction.attributes.custom_subject != null ? preEditWorkflowAction(subject,itemAction) : saveAction(subject, itemAction)"
            >{{ $t('confirm')}}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="typeAction =='certificate'" no-gutters>
          <v-col cols="12" align="left">
            <v-btn @click="downloadCertificate" data-testid="review-certificate-button" text class="text-none no-text-transform no-hover" color="accent">{{ $t('reviewCertificate') }}</v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
      <ConfirmationDialog 
        v-if="confirmDialog" 
        :visible="confirmDialog" 
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        cd-submit-btn-color="accent"
        :persistent="true" 
        @proceedSubmit="confirmDialogType == 'edit' ? editWorkflowAction(itemSelected.id,itemAction) : deleteWorkflowAction(itemAction)"  
        @close="confirmDialogType == 'edit' ? cancelEditBrokenAction() : cancelDeleteBrokenAction()">
      </ConfirmationDialog>

      <ConfirmationDialog 
        v-if="confirmDialogDelay" 
        :visible="confirmDialogDelay" 
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText"
        :cd-submit-btn="confirmationDialogSubmitBtn"
        :cd-cancel-btn="confirmationDialogCancelBtn"
        cd-submit-btn-color="accent"
        :persistent="true"
        data-testid="delay-dialog" 
        @proceedSubmit="confirmDialogDelayType == 'edit' ? editDelayWorkflowAction(itemAction) : deleteWorkflowAction(itemAction)"  
        @close="confirmDialogDelayType == 'edit' ? cancelEditDelayAction() : cancelDeleteDelayAction()">
      </ConfirmationDialog>
    </v-expansion-panel>
  </nav>
</template>
<script>
import i18n from "../../plugins/i18n";
import { repeatedMethodsMixin } from "../../mixins/repeatedMethodsMixin";
import { deleteWorkflowAction, downloadWorkflowCertificatePreview } from "../../api/workflowApi";
import { getEventTutors } from "../../api/eventApi";
import { searchSpaceUsers } from '../../api/spaceApi'
import ConfirmationDialog from "../ConfirmationDialog.vue";
import moment from 'moment'
import { ruleRequired, ruleValidMinCharacters, ruleValidMin2Max70Characters } from "../../rules/formRules.js";
import Vue from 'vue'
import EditorTextAreaTemplate from '../EditorTextAreaTemplate.vue';


Vue.prototype.moment = moment

export default {
  components: { 
    ConfirmationDialog, 
    EditorTextAreaTemplate
  },
  mixins: [repeatedMethodsMixin],
  props: {
    index: {
      type: Number,
      default: null
    },
    itemAction: {
      type: Object,
      default: () => {},
    },
    typeAction: {
      type: String,
      default: "share_activity",
    },
    activitiesList: {
      type: Array,
      default: () => [],
    },
    hubsList: {
      type: Array,
      default: () => [],
    },
    delayTime: {
      type: Number,
      default: 0
    },
    delayTillTime:{
      type: String,
      default: null
    },
    customSubject: {
      type: String,
      default: ''
    },
    customMessage: {
      type: String,
      default: ''
    },

    eventTitle:{
      type: String,
      default: null
    },
    eventType:{
      type: String,
      default: 'digital'
    },
    eventAt:{
      type: String,
      default: null
    },
    eventHasList:{
      type: Boolean,
      default: false
    },
    eventData:{
      type: Object,
      default: () =>{
        return {};
      }
    },
    eventTutors:{
      type: Array,
      default: () =>{
        return [];
      }
    },
    eventReminders:{
      type: Array,
      default: () =>{
        return [];
      }
    },
  },
  data() {
    return {
      // itemSelected: { attributes: { id: "none", title: i18n.t("choose") } },
      itemSelected: null,
      openedPanel: 1,
      errors: [],
      valid: true,
      activities: [],
      hubs: [],
      loading: false,
      workflowId: this.$route.params.id,
      confirmDialog: false,
      confirmDialogType: 'edit',
      confirmationDialogTitle: '',
      confirmationDialogText: '',
      confirmationDialogSubmitBtn: i18n.t('confirm'),
      confirmationDialogCancelBtn: i18n.t('cancel'),
      confirmDialogDelay: false,
      confirmDialogDelayType: 'edit',
      days: 0,
      hours: 0,
      minutes: 0,
      error: null,
      dateSelected: null,
      menu: false,
      time: Array(24 * 4)
        .fill(0)
        .map((_, i) => {
          return ("0" + ~~(i / 4) + ":0" + 60 * ((i / 4) % 1)).replace(
            /\d(\d\d)/g,
            "$1"
          );
        }),
      timeSelected: null,
      dateRules: ruleRequired('labelDate'),
      timeRules: ruleRequired('labelTime'),
      timezone: null,
      subject: null,
      message: null,
      subjectRules: ruleRequired('labelSubject').concat(ruleValidMinCharacters('labelSubject', 6)),
      messageShare: null,
      errorMsg: null,
      event:{title: null, type: null, event_at: null, url: null, tutors: null, has_list: false, data: null, reminders: []},
      minDate: new Date().toISOString().substr(0, 10),
      urlRules: ruleRequired('labelLink'),
      titleRules: ruleRequired('labelEventTitle').concat(ruleValidMin2Max70Characters('labelEventTitle')),
      isLoading:  false,
      entries:  [],
      selectedUsers:  [],
      search: null,
      oldReminders: [],
      oldEventInfo: [],
    };
  },
  computed: {
    workflow() {
      return this.$store.state.workflow
    },
    items () {
        return this.entries.map(entry => {
            const searchTerm = entry.attributes.first_name + ' ' + entry.attributes.last_name + ' ' + entry.attributes.email
            return Object.assign({}, entry, { searchTerm })
        })
    }
  },
  async mounted() {
    if(this.itemAction.attributes.event_reminders){
      this.oldReminders = JSON.parse(JSON.stringify(this.itemAction.attributes.event_reminders)) ?? [];
    }
    if(this.itemAction.attributes.event_reminders){
      this.oldEventInfo = JSON.parse(JSON.stringify(this.itemAction.attributes.event_data)) ?? [];
    }
  },
  async created() {
    this.loading = true; 
    this.hubs = this.hubsList;
    this.activities = this.activitiesList;
    this.messageShare = this.customMessage
    this.days = this.secondsToDays(this.delayTime);
    this.hours = this.secondsToHours(this.delayTime);
    this.minutes = this.secondsToMinutes(this.delayTime);
    this.timezone = 'UTC' + moment(new Date()).format('Z')
    this.subject = this.customSubject
    this.message = this.customMessage

    if(this.typeAction =='share_hub' || this.typeAction == 'remove_from_hub'){
      this.hubs = this.hubsList
      this.messageShare = this.customMessage
      if(this.itemAction.attributes.resource == null){
        this.hubs.unshift({
          attributes: { id: "none", title: i18n.t("choose") },
        }); 
      }
      this.setValue();

    }else if(this.typeAction =='share_activity' || this.typeAction == 'remove_from_activity'){
      this.activities = this.activitiesList
      this.messageShare = this.customMessage
      if(this.itemAction.attributes.resource == null){
        this.activities.unshift({
          attributes: { id: "none", title: i18n.t("choose") },
        });
      }
      this.setValue();

    }else if(this.typeAction =='delay_duration'){
      this.days = this.secondsToDays(this.delayTime);
      this.hours = this.secondsToHours(this.delayTime);
      this.minutes = this.secondsToMinutes(this.delayTime);

    }else if(this.typeAction =='delay_until'){
      //this.timezone = new Date().toLocaleTimeString('en-us',{timeZoneName:'short'}).split(' ')[2]
      //this.timezone = new Date().toString().match(/([A-Z]+[+-][0-9]+.*)/)[1]
      this.timezone = 'UTC' + moment(new Date()).format('Z')
      if(this.delayTillTime != null){
        const localDate = new Date(this.delayTillTime)    
        this.dateSelected = moment(localDate).format('YYYY-MM-DD')
        this.timeSelected = moment(localDate).format('HH:mm')
      }
     
    }else if(this.typeAction =='custom_message'){
      this.subject = this.customSubject
      this.message = this.customMessage
    } else if(this.typeAction =='certificate'){
      this.subject = this.customSubject
      this.message = this.customMessage
    } else if (this.typeAction =='event') {
      this.timezone = 'UTC' + moment(new Date()).format('Z')
      if(this.eventAt != null){
        const localDate = new Date(this.eventAt)    
        this.dateSelected = moment(localDate).format('YYYY-MM-DD')
        this.timeSelected = moment(localDate).format('HH:mm')
      }
      this.event = {
        title: this.eventTitle,
        type: this.eventType,
        event_at: this.eventAt,
        data: this.eventData,
        tutors: this.eventTutors,
        reminders: this.eventReminders,
        has_list: this.eventHasList
      }
      this.subject = this.customSubject
      this.message = this.customMessage
      if (this.eventTutors.length && this.itemAction.attributes.is_deleted == false) {
        this.getEventTutors();
      }
    }
    Vue.set(this.itemAction, "confirm", false);
    this.loading = false;
  },
  watch: {
    days(){
      this.error = null;
      var value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
      if(value != this.delayTime){
        this.validateDelayDuration()
      }else{
        Vue.set(this.itemAction, "confirm", false);
      }
    },
    hours(){
      this.error = null;
      var value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
      if(value != this.delayTime){
        this.validateDelayDuration()
      }else{
        Vue.set(this.itemAction, "confirm", false);
      }
      
    },
    minutes(){
      this.error = null;
      var value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
      if(value != this.delayTime){
        this.validateDelayDuration()
      }else{
        Vue.set(this.itemAction, "confirm", false);
      }
    },
    dateSelected(){
      this.error = null;
      if ((this.dateSelected != null && this.timeSelected == null) || (this.dateSelected == null && this.timeSelected != null)) {
        this.validateDateAndTime()
      }
      var timeKey;
      if (this.typeAction == 'delay_until') {
        timeKey = this.delayTillTime;
      } else if(this.typeAction == 'event') {
        timeKey = this.eventAt;
      }
      if (this.dateSelected != null && this.timeSelected != null) {
        var value = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString()
        if(!moment(value).isSame(moment(timeKey))){
          if(this.typeAction != 'event') {
            Vue.set(this.itemAction, "confirm", true);
          } else {
            this.isEventValid();
          }
          //validation is added here only to not show error message first time when only date is filled in
          if ((this.dateSelected == null && this.timeSelected == null) || (this.dateSelected == null && this.timeSelected != null)) {
            this.error = i18n.t("setRuleDateTimeRequiredError")
            Vue.set(this.itemAction, "confirm", false);
            return
          }
          else if(new moment(this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate() < new Date()){
            this.error = i18n.t("setRuleDateTimePastDateError")
            Vue.set(this.itemAction, "confirm", false);
            return
          }else{
            if(this.typeAction != 'event') {
              Vue.set(this.itemAction, "confirm", true);
            } else {
              this.isEventValid();
            }
          }
        }else{
          Vue.set(this.itemAction, "confirm", false);
        }
      }
    },
    timeSelected(){
      this.error = null;
      if ((this.dateSelected != null && this.timeSelected == null) || (this.dateSelected == null && this.timeSelected != null)) {
        this.validateDateAndTime()
      }
      var timeKey;
      if (this.typeAction == 'delay_until') {
        timeKey = this.delayTillTime;
      } else if(this.typeAction == 'event') {
        timeKey = this.eventAt;
      }
      if (this.dateSelected != null && this.timeSelected != null) {
        var value = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString()
        if(!moment(value).isSame(moment(timeKey))){
          if(this.typeAction != 'event') {
            Vue.set(this.itemAction, "confirm", true);
          } else {
            this.isEventValid();
          }
          this.validateDateAndTime()
        }else{
          Vue.set(this.itemAction, "confirm", false);
        }
      }
    },
    itemSelected(){
      if(this.itemSelected) {
        if(this.itemSelected.attributes.id != 'none' && this.strip(this.messageShare).trim().length != 1 && (this.itemSelected.id != this.itemAction.attributes.resource || this.customMessage != this.messageShare)){
          this.errors = []
          Vue.set(this.itemAction, "confirm", true);
        }else{
          Vue.set(this.itemAction, "confirm", false);
        }
      }else{
        Vue.set(this.itemAction, "confirm", false);
      }
      
    },
    messageShare(){
      this.errorMsg = null;
      if(this.itemSelected) {
        if(this.itemSelected.attributes.id != 'none' && this.strip(this.messageShare).trim().length != 1 && (this.itemSelected.id != this.itemAction.attributes.resource || this.customMessage != this.messageShare)){
          Vue.set(this.itemAction, "confirm", true);
        }else{
          if(this.strip(this.messageShare).trim().length == 1){
            this.errorMsg = i18n.t('nameErrorValidNumCharacters', { 'field': i18n.t('labelMessage') })
          }
          Vue.set(this.itemAction, "confirm", false);
        }
      } else{
        Vue.set(this.itemAction, "confirm", false);
      }
    },
    subject(){
      if(this.subject != '' && this.message != '' && this.subject.trim().length >= 6 && this.strip(this.message).trim().length >= 2 && (this.subject != this.customSubject || this.message != this.customMessage)){
        if(this.typeAction != 'event') {
          Vue.set(this.itemAction, "confirm", true);
        } else {
          this.isEventValid();
        }
      } else{
        Vue.set(this.itemAction, "confirm", false);
      }
    },
    message(){
      this.errorMsg = null
      if(this.subject != '' && this.message != '' && this.subject.trim().length >= 6 && this.strip(this.message).trim().length >= 2 && (this.subject != this.customSubject || this.message != this.customMessage)){
        if(this.typeAction != 'event') {
          Vue.set(this.itemAction, "confirm", true);
        } else {
          this.isEventValid();
        }
      }else{
        if(this.strip(this.message).trim().length == 1){
          this.errorMsg = i18n.t('nameErrorValidNumCharacters', { 'field': i18n.t('labelMessage') })
        } else if(this.strip(this.message).trim().length == 0){
          this.errorMsg = i18n.t('fieldErrorRequired', { 'field': i18n.t('labelMessage') })
        }
        Vue.set(this.itemAction, "confirm", false);
      }
    },
    event: {
      handler() {
        this.isEventValid();
      },
      deep: true, // This ensures deep watching
      // immediate: true, // Optional: Runs the watcher immediately on component mount
    },
    selectedUsers() {
      var users = this.selectedUsers.map(entry => {
        if(entry.id) {
            return entry.id
        }
      });
      Vue.set(this.event, 'tutors', users);
    },
    async search (val) {
      if (this.isLoading) return 

      var entriesUsers = []
      if (val && val.trim().length >= 2) {
          this.isLoading = true
          try {
              const response = await searchSpaceUsers(this.workflow.attributes.space, val)
              if(response.status == 200) {
                  entriesUsers = response.data.data
                  entriesUsers.forEach(function(item) {
                      item.sort_term = item.attributes.first_name.toLowerCase() + ' ' + item.attributes.last_name.toLowerCase() + ' ' + item.attributes.email.toLowerCase()
                  })
              }            
          } catch (e) {
              if(e.response){
                  this.alertValue = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
              }            
          }
          this.entries = entriesUsers
          this.isLoading = false
      }
      this.isLoading = false
    }
  },
  methods: {
    saveAction(value, item) {
      if(this.typeAction =='share_hub' || this.typeAction =='share_activity'){
        if(this.itemSelected.attributes.id != 'none' && this.strip(this.messageShare).trim().length != 1){
          value = {resource: this.itemSelected.id, message: this.messageShare}
        }else {
          return
        }
      }
      else if(this.typeAction =='delay_duration'){
        if(this.validateDelayDuration()){
          value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
        }else {
          return
        }
      }
      else if(this.typeAction =='delay_until'){
        if(this.validateDateAndTime()){
          value = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString()
        }else {
          return
        }
      }
      else if(this.typeAction =='custom_message'){
        this.valid = this.$refs.form.validate()
        if(this.valid){
          value = {subject: this.subject, message: this.message}
        }else {
          return
        }
      }else if(this.typeAction == 'remove_from_hub' || this.typeAction == 'remove_from_activity'){
        if(this.itemSelected.attributes.id != 'none'){
          value = {resource: this.itemSelected.id}
        }else {
          return
        }
      }
      else if(this.typeAction =='certificate'){
        this.valid = this.$refs.form.validate()
        if(this.valid){
          value = {subject: this.subject, message: this.message}
        }else {
          return
        }
      }
      else if(this.typeAction =='event'){
        this.valid = this.$refs.form.validate()
        if(this.validateDateAndTime() && this.valid) {
          value = {eventTitle: this.event.title, eventType: this.event.type, eventTutors: this.event.tutors, eventReminders: this.event.reminders, eventData: this.event.data, eventAt: moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString(), eventHasList: this.event.has_list,  subject: this.subject, message: this.message}
        }else {
          return
        }
      }
      this.$emit("proceedSubmit", value, item, this.index);
    },

    preEditWorkflowAction(value, item) {
      if(item.attributes.is_broken){
        this.confirmDialogType = 'edit';
        this.confirmationDialogTitle = i18n.t('confirmationDialogTitleFixBrokenWorkflow');
        this.confirmationDialogText = i18n.t('confirmationDialogTextFixBrokenWorkflow');
        this.confirmDialog = true;
      }else{
        if(this.typeAction == 'share_hub' || this.typeAction == 'share_activity'){
          if(this.itemSelected){
            if(this.itemSelected.attributes.id != 'none' && this.strip(this.messageShare).trim().length != 1 && (this.itemSelected.id != this.itemAction.attributes.resource || this.customMessage != this.messageShare)){
              value = {resource: this.itemSelected.id, message: this.messageShare}
              this.$emit("edit", value, item, this.index);
            }
          }
        }else if(this.typeAction == 'delay_duration'){
          if(item.meta && item.meta.jobs_scheduled && item.meta.jobs_scheduled > 0){
            if(this.validateDelayDuration()){
              this.confirmDialogDelayType = 'edit';
              this.confirmationDialogSubmitBtn= i18n.t('save');
              this.confirmationDialogTitle = i18n.t('confirmationDialogTitleEditDelayAction');
              this.confirmationDialogText = i18n.t('confirmationDialogTextEditDelayAction');
              this.confirmDialogDelay = true;
            }
          }else{
            if(this.validateDelayDuration()){
              value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
              if(value != this.delayTime){
                this.$emit("edit", value, item, this.index);
              }
            }
          }
        }else if(this.typeAction == 'delay_until'){
          if(this.validateDateAndTime()){
            value = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString()
            if(!moment(value).isSame(moment(this.delayTillTime))){
              this.$emit("edit", value, item, this.index);
            }
          }
        }else if(this.typeAction == 'custom_message'){
          this.valid = this.$refs.form.validate()
          if(this.valid && (this.subject != this.customSubject || this.message != this.customMessage)){
            value = {subject: this.subject, message: this.message}
            this.$emit("edit", value, item, this.index);
          }
        }else if(this.typeAction == 'remove_from_hub' || this.typeAction == 'remove_from_activity'){
          if(this.itemSelected){
            if(this.itemSelected.attributes.id != 'none' && this.itemSelected.id != this.itemAction.attributes.resource ){
              value = {resource: this.itemSelected.id}
              this.$emit("edit", value, item, this.index);
            }
          }
        } else if(this.typeAction == 'certificate'){
          this.valid = this.$refs.form.validate()
          if(this.valid && (this.subject != this.customSubject || this.message != this.customMessage)){
            value = {subject: this.subject, message: this.message}
            this.$emit("edit", value, item, this.index);
          }
        } else if(this.typeAction == 'event'){
          this.valid = this.$refs.form.validate();
          if(this.isEventValid() && this.valid) {
            value = {eventTitle: this.event.title, eventType: this.event.type, eventTutors: this.event.tutors, eventReminders: this.event.reminders, eventData: this.event.data, eventAt: moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString(), eventHasList: this.event.has_list,  subject: this.subject, message: this.message}
            this.$emit("edit", value, item, this.index);
          }
        }  
      }
    },

    cancelEditBrokenAction(){
      this.setValue()
      this.confirmDialog = false;
    },

    cancelDeleteBrokenAction(){
      this.confirmDialog = false;
    },

    cancelEditDelayAction(){
      this.confirmDialogDelay = false;
      Vue.set(this.itemAction, "confirm", true);

    },

    cancelDeleteDelayAction(){
      this.confirmDialogDelay = false;
    },

    editWorkflowAction(id, item){
      const value = {resource: id, message: this.messageShare}
      this.$emit("editAndSave", value, item, this.index);
      this.confirmDialog = false;
    },

    editDelayWorkflowAction(item){
      const value = (this.days * 24 * 60 * 60) + (this.hours * 60 * 60) + (this.minutes * 60)
      this.$emit("edit", value, item, this.index);
      this.confirmDialogDelay = false;      
    },

     async preDeleteWorkflowAction(item) {
      if(item.attributes.is_broken){
        this.confirmDialogType = 'delete';
        this.confirmationDialogTitle = i18n.t('confirmationDialogTitleFixBrokenWorkflow');
        this.confirmationDialogText = i18n.t('confirmationDialogTextFixBrokenWorkflow');
        this.confirmDialog = true;
      }else{
        if((this.typeAction == 'delay_duration' && item.meta && item.meta.jobs_scheduled && item.meta.jobs_scheduled > 0) || (this.typeAction == 'delay_until' && item.attributes && item.attributes.is_active == true && new moment(this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate() >= new Date())){
          this.confirmDialogDelayType = 'delete'
          this.confirmationDialogSubmitBtn= i18n.t('confirm');
          this.confirmationDialogTitle = i18n.t('confirmationDialogTitleDeleteDelayAction');
          this.confirmationDialogText = i18n.t('confirmationDialogTextDeleteDelayAction');
          this.confirmDialogDelay = true;
        }else {
          this.deleteWorkflowAction(item);
        }
      }
    },
    
    async deleteWorkflowAction(item) {
      if (item.relationships) {
        try {
          var data = {};
          data = {
            data: {
              id: item.id,
              type: "workflow-actions",
              attributes: {
                is_deleted: true,
              },
              relationships: {
                workflow: {
                  data: {
                    type: "workflows",
                    id: this.workflowId,
                  },
                },
                "action-type": {
                  data: {
                    type: "action-types",
                    id: item.relationships["action-types"].meta.id.toString(),
                  },
                },
              },
            },
          }
          const response = await deleteWorkflowAction(item.id, data);
          if (response.status == 200) {
            this.$emit("afterDelete", item, this.index, response.data.data);
            if(item.attributes.is_broken){
              //to fix broken status on workflow level
              this.$emit("deleteAndSave", this.index);
            }
          }
        } catch (e) {
          if (e.response) {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
            if (e.response.status == 403) {
              this.$router.push({ name: "PageAccessDenied" });
            } else {
              this.alertType = "error";
              this.alertMsg = i18n.t("serverError");
              this.alertValue = true;
            }
          }
        }
      } else {
        this.$emit("afterDelete", item, this.index, null);
      }
    },
    async getEventTutors() {
      try {
        const response = await getEventTutors(this.itemAction.attributes.event_id);
        if (response.status == 200) {
          const data = response.data.data.map(item => ({
            id: item.id,
            attributes: item.attributes,
            searchTerm: `${item.attributes.first_name} ${item.attributes.last_name} (${item.attributes.email})`,
            sort_term : item.attributes.first_name.toLowerCase() + " " + item.attributes.last_name.toLowerCase() + " " + item.attributes.email.toLowerCase(),
          }));
          this.entries = data;

          if (Array.isArray(this.event.tutors)) {
            this.selectedUsers = this.entries.filter(user => this.event.tutors.includes(user.id));
          }

          // this.selectedUsers = [...data];
          // var users = this.selectedUsers.map(entry => {
          //   if(entry.id) {
          //       return entry.id
          //   }
          // });
          // Vue.set(this.event, 'tutors', users);
        }
      } catch (e) {
        if (e.response) {
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          this.alertValue = true;
          if (e.response.status == 403) {
            this.$router.push({ name: "PageAccessDenied" });
          } else {
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
            this.alertValue = true;
          }
        }
      }
    },

    setValue(){
      if(this.itemAction.attributes.team_type == 'hub' ){
      if(this.itemAction.attributes.resource != null){
        const selected = this.hubs.findIndex(item => item.id == this.itemAction.attributes.resource)
        if(selected == -1){
          this.hubs.unshift({
            attributes: { id: "none", title: i18n.t("choose") },
          }); 
          this.itemSelected = { attributes: { id: "none", title: i18n.t("choose") } }
        }else{
          this.itemSelected = this.hubs[selected]
        }
      }
    } else{
      if(this.itemAction.attributes.resource != null){
        const selected = this.activities.findIndex(item => item.id == this.itemAction.attributes.resource)
        if(selected == -1){
          this.activities.unshift({
            attributes: { id: "none", title: i18n.t("choose") },
          });
          this.itemSelected = { attributes: { id: "none", title: i18n.t("choose") } }
        }else{
          this.itemSelected = this.activities[selected]
        }
      }
    }

    },
    preventLetters(e){
      e = e || window.event;
      var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      var charStr = String.fromCharCode(charCode);
      if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();   
    },

    allowedDates(val){
      return val >= new Date().toISOString().substr(0, 10)
    },

    validateDelayDuration(){
      if(this.days == 0 && this.hours == 0 && this.minutes == 0){
        this.error = i18n.t('delayActionErrorTimeRequired');
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }else if(this.days > 2000){
        this.error = i18n.t('delayActionErrorDays');
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }else if(this.hours > 23){
        this.error = i18n.t('delayActionErrorHours');
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }else if(this.minutes > 59){
        this.error = i18n.t('delayActionErrorMinutes');
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }
      Vue.set(this.itemAction, "confirm", true);
      return true;
    },

    validateDateAndTime(){
      if ((this.dateSelected == null && this.timeSelected == null) || (this.dateSelected != null && this.timeSelected == null) || (this.dateSelected == null && this.timeSelected != null)) {
        this.error = i18n.t("setRuleDateTimeRequiredError")
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }
      else if(new moment(this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate() < new Date()){
        this.error = i18n.t("setRuleDateTimePastDateError")
        Vue.set(this.itemAction, "confirm", false);
        return false;
      }
      if(this.typeAction != 'event') {
          Vue.set(this.itemAction, "confirm", true);
      } else {
        this.isEventValid();
      }
      return true;
    },

    updateContentCustomMessage(content) {
      if (content != '') {
        this.message = content
      }
    },
    updateContentShareMessage(content) {
      if (content != '') {
        this.messageShare = content
      }
    },
    updateContentCertificate(content) {
      if (content != '') {
        this.message = content
      }
    },
    onPlaceSelected(place, result) {
      Vue.set(this.event.data, "address", result.formatted_address);
      Vue.set(this.event.data, "googleMapsLink", `https://www.google.com/maps?q=${place.latitude},${place.longitude}`);
      Vue.set(this.event.data, "location", place);
    },

    async downloadCertificate() {
      try {
          const response = await downloadWorkflowCertificatePreview(this.workflowId);
          if (response.status) {
              if (response.status == 200) {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute("crossorigin", "anonymous");
                  link.setAttribute('download', 'workflow-certificate.pdf');
                  document.body.appendChild(link);
                  link.click();
              }
          }
      } catch (e) {
          if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
          }
      }
    },
    closeSearch(){
      this.search = ''
      this.entries = this.selectedUsers.slice();
    },
    change(){
        this.search = ''
    },
    remove(item) {
      this.selectedUsers = this.selectedUsers.filter(selectedUser => selectedUser.id !== item.id);
    },
    
    checkUserExist(){
      return true;
    },

    isEventValid() {
      this.errorMsg = null;
      let titleValid = false;
      let typeValid = false;
      let dataValid = false;
      let hasVenue = false;
      let hasTutors = false;
      let hasValidSubjectMessage = false;
      let hasValidDateTime = false;
      let dataUpdated = false;
      let hasValidReminders = true;
      // let timeUpdated = false;
      // let reminderUpdated = false;
      // let tutorUpdated = false;
      // let infoUpdated = false;

      if(this.subject != '' && this.message != '' && this.subject.trim().length >= 6 && this.strip(this.message).trim().length >= 2 ){
        hasValidSubjectMessage = true;
        if((this.subject != this.customSubject || this.message != this.customMessage)){
          dataUpdated = true;
        }
      }

      if (this.event.title && this.event.title.trim().length >= 2) {
        titleValid = true;
        if(this.event.title !== this.eventTitle){
          dataUpdated = true
        }
      }

      if (this.event.type) {
        typeValid = true;
        if(this.event.type !== this.eventType){
          dataUpdated = true
        }
      }
      if(this.event.has_list !== this.eventHasList){
        dataUpdated = true
      }
      if(!this.event.has_list){
        hasTutors = true;
      }
      if (this.event.tutors.length) {
        hasTutors = true;
        if(JSON.stringify(this.event.tutors) !== JSON.stringify(this.eventTutors)){
          dataUpdated = true;
          // tutorUpdated = true;
        }
      }
      if (this.event.reminders.length) {
        this.event.reminders.filter((item) => {
          if (item.error != '' && item.error != null) {
            hasValidReminders = false;
          }
        })
        if(JSON.stringify(this.event.reminders) !== JSON.stringify(this.oldReminders)){
          dataUpdated = true;
          // reminderUpdated = true;
        }
      }

      if (this.event.data) {
        dataValid = true;
        if(JSON.stringify(this.event.data) !== JSON.stringify(this.oldEventInfo)){
          dataUpdated = true
          // infoUpdated = true
        }
        if (this.event.data.url || this.event.data.address) {
          if (this.event.data.url && this.event.data.url.trim().length >= 2) {
            hasVenue = true
          } else if(this.event.data.address && this.event.data.address.trim().length >= 2){ 
            hasVenue = true
          }
        }
      }

      if (this.dateSelected != null && this.timeSelected != null) {
        var value = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString();
        hasValidDateTime = true;
        if(!moment(value).isSame(moment(this.eventAt))){
          dataUpdated = true;
          // timeUpdated = true;
        }
      }

      // console.log('checking if valid',titleValid, typeValid, dataValid, hasTutors, hasValidSubjectMessage, hasValidDateTime, hasValidReminders, hasVenue, 'checking if changed', dataUpdated, infoUpdated, timeUpdated, tutorUpdated, reminderUpdated);

      if (titleValid && typeValid && dataValid &&  hasTutors && hasValidSubjectMessage && hasValidDateTime && hasVenue && hasValidReminders && (dataUpdated)) {
        Vue.set(this.itemAction, "confirm", true);
        return true;
      } else {
        Vue.set(this.itemAction, "confirm", false);
      }      
    },

      
    addNewRow() {
      if (this.event.reminders.length < 15) {
        if (this.event.reminders.every((item) => item.days !== "")) {
          this.event.reminders.push({
              days: "0",
              date: new Date(),
          });
          this.getDateFromDays(this.event.reminders.length - 1);
        }
      }
    },

    removeRow (i){
        this.event.reminders.splice(i, 1);
        // this.event.clearErrors(`reminders.${i}.days`)
        this.adjustReminders();
    },

    getDateFromDays(i, doNotCheck = false) {
      const days = this.event.reminders[i].days;
      //if (!days) return;
      if (days === "" || days < 0) {
        this.event.reminders[i].error = i18n.t('invalid_date');
      //   this.event.setError(`reminders.${i}.days`, ("validation.days_negative"));
          return;
      }
      const duplicateDays = this.event.reminders.filter(
          (item, index) => index !== i && item.days === days
      );
      var dateField = moment( this.dateSelected + " " + this.timeSelected, 'YYYY-MM-DD HH:mm').toDate().toISOString();
      var date = new Date(dateField);
      date.setDate(date.getDate() - days);
      this.event.reminders[i].date = date;
      Vue.set(this.event.reminders[i], 'date', date);
      if (duplicateDays.length > 0) {
        this.event.reminders[i].error = i18n.t('repeated_date');
          // this.event.setError(`reminders.${i}.days`, trans("validation.days_repeated"));
          return;
      } else {
          this.event.reminders[i].error = "";
          // this.event.clearErrors(`reminders.${i}.days`);
          if (!doNotCheck) {
              this.adjustReminders();
          }
      }
      var today = new Date();
      // today.setHours(0, 0, 0, 0);
      if (moment(date).format("YYYY-MM-DD") <= moment(today).format("YYYY-MM-DD")) {
        this.event.reminders[i].error = i18n.t('invalid_date');
          // this.event.setError(`reminders.${i}.days`, trans("validation.days_negative"));
      }
    },

    adjustReminders() {
        // this.event.clearErrors();
        this.event.reminders.forEach((reminder, i) => {
            this.getDateFromDays(i, true);
        });
    },

  },
};
</script>
<style>
.v-expansion-panel-header__icon {
  align-self: start;
}
.v-expansion-panel-header__icon .v-icon {
  padding: 4px;
  font-size: 30px;
  margin-top: 2px;
}
.workflow-action-select .v-list-item--active{
  pointer-events: none;
  
}
.v-list-item--active span.text-subtitle-2 {
  color: var(--v-greytextlight-base) !important;
}
.autocomplete-google {
  width: 100%;
    box-shadow: 0px 3px 1px -2px rgba(38, 50, 56, 0.1), 0px 2px 2px 0px rgba(38, 50, 56, 0.1), 0px 1px 5px 0px rgba(38, 50, 56, 0.1);
    margin-bottom: 10px;
    height: 50px;
    padding: 5px 5px 5px 15px;
    outline: unset;
}
</style>
